import * as React from "react";
const SortIcon = (props) => (
	<svg
		width={13}
		height={10}
		viewBox="0 0 13 10"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M.667 9.334h8M.667 6h6m-6-3.333h4m5.333 4V1.334m0 0 2 2m-2-2-2 2"
			stroke="#5E666B"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default SortIcon;
